<template>
  <div class="role-list">
    <!-- 系统管理-角色管理（企业微信手机端，仅查看） -->
    <mobile-list-header>
      <div class="search-bar">
        <div class="search-input">
          <yq-icon class="icon" name="element-ui_search"/>
          <input v-model="searchKey" placeholder="角色名称" @keyup.enter="noop"/>
          <yq-icon v-if="searchKey" class="icon clear" name="element-ui_close" @click="searchKey = ''"/>
        </div>
        <div class="search-btn" @click="noop">搜索</div>
      </div>
    </mobile-list-header>

    <div class="role-body" v-loading="loading">
      <list-card class="role-item" v-for="item in filteredRoles" :key="item.id" :label="item.roleName"
                 @click="toDetail(item)">
        <template #desc>
          <span class="type-tag" :class="Number(item.roleType) === 1 ? 'admin' : 'normal'">
            {{ Number(item.roleType) === 1 ? "超级管理员" : "普通角色" }}
          </span>
          <yq-icon class="item-arrow" name="element-ui_arrow-right"/>
        </template>
        <data-column label="岗位">{{ businessTypeName(item.businessType) || "—" }}</data-column>
        <data-column label="角色描述">{{ item.roleDescription || "—" }}</data-column>
        <data-column label="创建时间">{{ dateTime(item.createdTime) }}</data-column>
      </list-card>
      <div v-if="!loading && filteredRoles.length === 0" class="empty">暂无角色</div>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import MobileListHeader from "@/components/qywx/layout/MobileListHeader.vue";
import ListCard from "@/components/qywx/layout/ListCard.vue";
import DataColumn from "@/components/qywx/data/DataColumn.vue";
import YqIcon from "@/components/YqIcon.vue";
import roleApi from "@/api/normal/sys/roleApi";
import commonApi from "@/api/commonApi";
import Util from "@/util/util";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "RoleListQW",
  components: {
    YqIcon, DataColumn, ListCard, MobileListHeader
  },
  data() {
    return {
      loading: false,
      searchKey: "",
      roleList: [],
      businessTypeList: [],
    };
  },
  computed: {
    filteredRoles() {
      const key = (this.searchKey || "").trim();
      if (!key) {
        return this.roleList;
      }
      return this.roleList.filter(role => (role.roleName || "").indexOf(key) > -1);
    }
  },
  created() {
    this.loading = true;
    Util.getUserInfo().then(user => {
      roleApi.queryAllRoles(user.merchantId).then(list => {
        this.roleList = list || [];
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    });
    // 岗位（角色业务类型）字典
    commonApi.queryUniqueDictionaryList("POSITION_ROLE").then(list => this.businessTypeList = list || []);
  },
  methods: {
    noop() {
      // 本地过滤，回车/搜索按钮只用于聚焦刷新视图
    },
    businessTypeName(code) {
      if (!code) {
        return "";
      }
      const item = this.businessTypeList.find(t => t.dictCode === code);
      return item ? item.dictName : code;
    },
    dateTime(value) {
      return value ? String(value).slice(0, 16) : "—";
    },
    toDetail(item) {
      this.router.push(`/qywx/sys/role/detail?id=${item.id}`);
    },
  }
};
</script>

<style lang="scss" scoped>
.role-list{
  height: 100%;
  display: flex;
  flex-direction: column;
}
.search-bar{
  display: flex;
  align-items: center;
  height: 44px;
  padding-left: 12px;
  border-radius: 999px;
  background: var(--yq-background-color);
  overflow: hidden;
  .search-input{
    flex: 1;
    display: flex;
    align-items: center;
    min-width: 0;
    height: 100%;
    padding-right: 12px;
    .icon{
      flex: none;
      color: var(--yq-font-color-desc);
      font-size: var(--yq-font-size-mini-mobile);
      &.clear{
        margin-left: 6px;
      }
    }
    input{
      flex: 1;
      min-width: 0;
      height: 100%;
      margin-left: 6px;
      border: none;
      outline: none;
      background: transparent;
      font-size: var(--yq-font-size-mini-mobile);
      color: var(--yq-font-color-base);
      &::placeholder{
        color: var(--yq-font-color-desc);
      }
    }
  }
  .search-btn{
    flex: none;
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 18px;
    background: var(--el-color-primary);
    color: #FFF;
    font-size: var(--yq-font-size-mini-mobile);
  }
}
.role-body{
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  box-sizing: border-box;
}
.role-item{
  :deep(.card-title .desc){
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .type-tag{
    flex: none;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: var(--yq-font-size-mini-mobile);
    &.admin{
      color: var(--el-color-warning);
      background: var(--el-color-warning-light-9);
    }
    &.normal{
      color: var(--el-color-primary);
      background: var(--el-color-primary-light-9);
    }
  }
  .item-arrow{
    color: var(--yq-font-color-desc);
    font-size: var(--yq-font-size-mini-mobile);
  }
}
.empty{
  padding: 30px 0;
  text-align: center;
  font-size: var(--yq-font-size-mini-mobile);
  color: var(--yq-font-color-desc);
}
</style>
